import { ToolbarActionsLane } from "@-/dev.improve.haniverse.components.ui.toolbar.button.icon";
import { FrostedBackdropTarget } from "@-/dev.improve.haniverse.components.ui.frosted-surface";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import {
  BrowseWordsFrequencyToolbarActions,
  BrowseWordsHskToolbarActions,
  BrowseWordsPageToolbar,
} from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.words._components.toolbar";
import { BrowseWordsPageContext } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.words._context";
import { WordsFrequencyView } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.words._views.frequency";
import { WordsHskView } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.words._views.hsk";
import { SuspensePageBoundary } from "@-/dev.improve.haniverse.components.ui.suspense-page";
import { BrowseWordsSkeleton } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs._components.loading-skeletons";
import { LazyBrowseTabContent } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs._lib.focus";
import { View } from "@-/com.npmjs.react-native";
import { PrimaryControlsStripToolbar } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.toolbar";

export function BrowseWordsPageContent() {
  const [sortMode, setSortMode] = useContextSelectors(
    BrowseWordsPageContext,
    (c) => c.sortMode,
    (c) => c.setSortMode,
  );
  // Frequency scrolls under the bar (iOS 26 glass). HSK pins material tabs under it, so the
  // shared header fade must stay off — same opaque-chrome pattern as Characters grade / Levels.
  const isFloating = sortMode === "frequency";
  return (
    <View className="flex-1 bg-background">
      <FrostedBackdropTarget className="min-h-0 flex-1">
        <SuspensePageBoundary fallback={<BrowseWordsSkeleton />} location={import.meta.location}>
          <LazyBrowseTabContent fallback={<BrowseWordsSkeleton />}>
            {sortMode === "frequency" ? <WordsFrequencyView /> : <WordsHskView />}
          </LazyBrowseTabContent>
        </SuspensePageBoundary>
      </FrostedBackdropTarget>
      <PrimaryControlsStripToolbar
        className="absolute inset-x-0 top-0 z-0"
        floating={isFloating}
        pointerEvents="none"
        stripFade={isFloating}
      />
      {/* The page shell keeps route pills visible while a view is resolving. */}
      <View className="absolute top-0 left-0 z-10" pointerEvents="box-none">
        <BrowseWordsPageToolbar onSortModeChange={setSortMode} sortMode={sortMode} />
      </View>
      <ToolbarActionsLane>
        {sortMode === "hsk" ? (
          <BrowseWordsHskToolbarActions />
        ) : (
          <BrowseWordsFrequencyToolbarActions />
        )}
      </ToolbarActionsLane>
    </View>
  );
}
